// Performs a full page navigation. Routing it through one helper lets tests
// assert navigation by mocking this module, which newer jsdom requires since it
// no longer lets tests replace window.location.
const redirectTo = (url: string): void => {
  window.location.assign(url);
};

export default redirectTo;
